import React from 'react';
import { Box } from '@mui/material';
import { Dialog } from '../../../../Components/MUIs';
import './SerEvalDeleteConfirmDialog.styles.css';

export const DELETE_CONFIRM_TYPE = {
  CATEGORY: 'category',
  INDICATOR: 'indicator',
  CHECKPOINT: 'checkpoint',
  FORM: 'form',
};

const TYPE_META = {
  [DELETE_CONFIRM_TYPE.CATEGORY]: {
    icon: 'folder_delete',
    targetIcon: 'category',
    targetLabel: '삭제할 대분류',
    introTitle: '대분류를 삭제합니다',
    defaultNotice: '포함된 평가지표·착안사항이 모두 함께 삭제되며, 복구할 수 없습니다.',
  },
  [DELETE_CONFIRM_TYPE.INDICATOR]: {
    icon: 'fact_check',
    targetIcon: 'analytics',
    targetLabel: '삭제할 평가지표',
    introTitle: '평가지표를 삭제합니다',
    defaultNotice: '하위 착안사항이 모두 함께 삭제되며, 복구할 수 없습니다.',
  },
  [DELETE_CONFIRM_TYPE.CHECKPOINT]: {
    icon: 'checklist',
    targetIcon: 'checklist',
    targetLabel: '삭제할 착안사항',
    introTitle: '착안사항을 삭제합니다',
    defaultNotice: '삭제한 내용은 복구할 수 없습니다.',
  },
  [DELETE_CONFIRM_TYPE.FORM]: {
    icon: 'description',
    targetIcon: 'draft',
    targetLabel: '삭제할 평가 양식',
    introTitle: '평가 양식을 삭제합니다',
    defaultNotice:
      '이 양식으로 작성된 평가가 있으면 삭제할 수 없습니다. 삭제한 양식은 복구할 수 없습니다.',
  },
};

/** 중대재해 평가 구조 삭제 확인 다이얼로그 */
function SerEvalDeleteConfirmDialog({
  open = false,
  type = DELETE_CONFIRM_TYPE.CHECKPOINT,
  title = '삭제 확인',
  targetName = '',
  message = '',
  onClose,
  onConfirm,
}) {
  const meta = TYPE_META[type] || TYPE_META[DELETE_CONFIRM_TYPE.CHECKPOINT];
  const notice = message || meta.defaultNotice;
  const displayName = String(targetName || '').trim() || '선택한 항목';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="sm"
      fullWidth
      useSaveButton={false}
      useCloseButton={false}
      titleSx={{ pb: 2, fontWeight: 700 }}
      contentSx={{ pt: 3, px: 2.5, pb: 2 }}
      actions={
        <div className="ser-delete-dialog__actions">
          <button
            type="button"
            className="ser-delete-dialog__btn ser-delete-dialog__btn--cancel"
            onClick={onClose}
          >
            취소
          </button>
          <button
            type="button"
            className="ser-delete-dialog__btn ser-delete-dialog__btn--delete"
            onClick={onConfirm}
          >
            삭제
          </button>
        </div>
      }
      content={
        <Box
          className="ser-delete-dialog"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <div className="ser-delete-dialog__intro">
            <div className="ser-delete-dialog__intro-icon">
              <span className="material-symbols-outlined">{meta.icon}</span>
            </div>
            <div>
              <div className="ser-delete-dialog__intro-title">{meta.introTitle}</div>
              <p className="ser-delete-dialog__intro-desc">
                삭제 후에는 되돌릴 수 없습니다. 계속 진행하시겠습니까?
              </p>
            </div>
          </div>

          <div className="ser-delete-dialog__target-card">
            <div className="ser-delete-dialog__target-label">{meta.targetLabel}</div>
            <div className="ser-delete-dialog__target-name">
              <span className="ser-delete-dialog__target-icon">
                <span className="material-symbols-outlined">{meta.targetIcon}</span>
              </span>
              {displayName}
            </div>
          </div>

          <div className="ser-delete-dialog__notice">
            <span className="material-symbols-outlined">info</span>
            <span>{notice}</span>
          </div>
        </Box>
      }
    />
  );
}

export default SerEvalDeleteConfirmDialog;
